import React, { useMemo } from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPActionButton, When } from 'UI/components/atoms';
import { FPButtonMenu } from 'UI/components/molecules';

import { useBulkEmailSequencesPreviewItemStyles } from './BulkEmailSequencesPreviewItem.styles';

const { sequences: sequencesCopies } = strings.bulkEmails.preview;
const { sent: sentCopies } = strings.bulkEmails.content;

export const BulkEmailSequencesPreviewItem = ({
  children,
  delayDays,
  isCanceled,
  isLastElement,
  menuButtonProps = { visible: true, menuItems: { edit: { visible: true } } },
  onOpenCancelDialog,
  onOpenEditStepDrawer,
  onOpenStatsDrawer,
  sectionKey,
  shouldEnableMenuButton,
  shouldEnableStatsButton
}) => {
  const classes = useBulkEmailSequencesPreviewItemStyles();
  const finalTitle = useMemo(() => {
    const stepTitle = strings.formatString(sequencesCopies.title, {
      step: sectionKey
    });
    const detailSuffix = strings.formatString(sequencesCopies.delayDetail, {
      days: delayDays,
      daysLabel:
        delayDays > 1 ? sequencesCopies.dayLabels.plural : sequencesCopies.dayLabels.singular
    });
    return delayDays ? `${stepTitle} ${detailSuffix}` : stepTitle;
  }, [delayDays, sectionKey]);

  return (
    <>
      <Grid container item data-testid={`${sectionKey}-meta-row`}>
        <Grid
          container
          item
          alignItems="center"
          justifyContent="space-between"
          className={classes.sectionTitleContainer}
        >
          <When condition={!isCanceled}>
            <Grid item>
              <Typography variant="overline">{finalTitle}</Typography>
            </Grid>
            <Grid item>
              <FPActionButton
                disabled={!shouldEnableStatsButton}
                size="small"
                variant="contained"
                text={sentCopies.bulkStatsButton}
                onClick={onOpenStatsDrawer}
                className={classes.statsButton}
              />
              <When condition={menuButtonProps.visible}>
                <FPButtonMenu
                  disabled={!shouldEnableMenuButton}
                  isIconButton
                  menuItems={[
                    {
                      title: sequencesCopies.actions.edit,
                      action: onOpenEditStepDrawer,
                      visible: menuButtonProps.menuItems.edit.visible
                    },
                    {
                      title: sequencesCopies.actions.cancelStep,
                      action: onOpenCancelDialog,
                      visible: true
                    }
                  ]}
                />
              </When>
            </Grid>
          </When>
        </Grid>
        {children}
      </Grid>
      <When condition={isLastElement}>
        <Divider className={classes.divider} />
      </When>
    </>
  );
};
